
import payforList from "../../component/payforList/index";
import goodInfo from "../../component/goodInfo/index";
import httpApi from "../../api/cashier";
import VueScroller from "vue-scroller";
import { Toast } from "mint-ui";
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default {
name: "order",
data() {
return {
type1: "全部",
type: "",
options: ["0", "wechat", "alipay", "virtual", "ccb"],
options1: ["全部", "微信", "支付宝", "虚拟卡", "建行支付"],
a: false,
dataList: [],
minuteListValue: "",
EndMinuteListValue: "",
device_id: "",
subject: "",
amountList: {},
next: false, //是否加载
page: 1, //当前页码,
page_size: 10,
payforList: [
{
iconImg: require("../../assets/img/pay_wechat@2x.png"),
tit: "wechat"
},
{
iconImg: require("../../assets/img/pay_card@2x.png"),
tit: "virtual"
},
{
iconImg: require("../../assets/img/pay_alipay@2x.png"),
tit: "alipay"
},
{
iconImg: require("../../assets/img/jianhang.png"),
tit: "ccb"
}
],
zanwu: false
};
},
components: {

payforList,
goodInfo,
Datetime,
PopupRadio,
VueScroller
},
created() {
this.getDate();
},
mounted() {
this.device_id = Number(this.$route.query.device_id);
this.subject = this.$route.query.subject;
this.userInfo = JSON.parse(window.localStorage.getItem("user"));
this.$refs.myscroller.finishInfinite(true);
this.zanwu = true;
this.getData(0);
},
methods: {
infinite(done) {
console.log("jiazai");
console.log(this.next);
if (this.next) {
this.getData(1);
}
},
getData(id) {
let _this = this;
console.log(id);

if (id == 0) {
_this.dataList = [];
_this.page = 1;
}
let data = {
device_id: this.device_id,
pay_type: this.type == "0" ? "" : this.type,
start_time: this.minuteListValue + " 00:00:00",
end_time: this.EndMinuteListValue + " 23:59:59"
};
let data2 = { ...data };
data2.page_num = this.page;
data2.page_size = this.page_size;

httpApi.getList(data2).then(res => {
_this.a = true;
_this.next = true;
for (let i in res.data.list) {
_this.dataList.push(res.data.list[i]);
}
console.log(_this.dataList);
if (res.data.list.length === 0) {
_this.zanwu = true;
} else {
_this.$refs.myscroller.finishPullToRefresh();
_this.$refs.myscroller.finishInfinite(false);
_this.zanwu = false;
}

if (res.data.total > _this.dataList.length) {
_this.page++;
} else {
_this.next = false;
}
});

if (id == 0) {
console.log("pppp");
httpApi.getAmount(data).then(res => {
if (res.status == 200) {
_this.amountList = res.data[0];
}
});
}
},
getDate() {
let date = new Date();
let seperator1 = "-";
let year = date.getFullYear();
let month = date.getMonth() + 1;
let strDate = date.getDate();
if (month >= 1 && month <= 9) {
month = "0" + month;
}
if (strDate >= 0 && strDate <= 9) {
strDate = "0" + strDate;
}
let currentdate = year + seperator1 + month + seperator1 + strDate;
this.minuteListValue = currentdate;
this.EndMinuteListValue = currentdate;
}
},
watch: {
type1(val) {
let index = 0;
for (let i in this.options1) {
console.log(this.options1[i], val);
if (this.options1[i] == val) {
index = i;
}
}
this.type = this.options[index];
if (this.a) {
this.getData(0);
}
},
minuteListValue(val) {
console.log(val, 6);
if (this.a) {
this.getData(0);
}
},
EndMinuteListValue(val) {
console.log(val, 5);
if (this.a) {
this.getData(0);
}
}
}
};




// WEBPACK FOOTER //
// ./src/components/statistics/index.vue